export const DROPDOWN_KEY = 'reports'
export const BUTTONSARRAY_KEY = 'reportBlocks'
export const BUTTONS_CONTROLS_KEY = 'reportControls'

export const REPORT_RIBBON_CHANGE_EVENT = 'REPORT_RIBBON_CHANGE_EVENT'
